import React from 'react';
//import HeaderSearch from 'ant-design-pro/lib/HeaderSearch';
 import {Input} from 'antd';



const { Search } = Input;

interface SearchInterface {
    placeholder: string;
    onSearch: (value: string) => void;
    // onPressEnter: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onPressEnter: (e: any) => void;
    style?: React.CSSProperties;
}
type SearchProps = SearchInterface;

const HSearch: React.FC<SearchProps> = (props) =>  {
    const {placeholder, onSearch, onPressEnter, style} = props;

        // let opened: boolean = (!isNullOrUndefined(defaultOpen) ? defaultOpen : false);
        return (
            <Search
                style={style}
                placeholder={placeholder}
                onSearch={onSearch}
                onPressEnter={onPressEnter}
            />
        );
}
export default HSearch;